import React from "react";
import { useSelector } from "react-redux";
import Dashboard from "./Dashboard";
import Landing from "./Landing";
import { getUserState } from "../../app/selector";

// Unified, mobile-friendly full-screen loader
const FullScreenLoader = () => (
  <div
    className="d-flex flex-column justify-content-center align-items-center bg-light w-100 px-3"
    style={{ minHeight: "100vh" }}
  >

    <h5 className="mt-4 text-muted text-center">Securing your session...</h5>
  </div>
);

const Home = () => {
  const { loggedIn, isCheckingAuth } = useSelector(getUserState);

  if (isCheckingAuth) {
    return <FullScreenLoader />;
  }

  return <div>{loggedIn ? <Dashboard /> : <Landing />}</div>;
};

export default Home;